<template lang="pug">
  .lesson__header
    .navigation.lesson__navigation
      template(v-if="!gettingLesson")
        .navigation__block.navigation__block_prev.lesson-prev(
          v-if="prevLesson.id && currentLesson.position !== 1"
        )
          //- p.navigation__descr Предыдущий урок

          router-link(:to="`${this.isFranch ? '/franch' : ''}/courses/lesson/${prevLesson.id}`").navigation__accent
            Icon( icon="lesson-arrow")
            | Предыдущий урок
            //- | {{prevLesson.name}}

      template(v-else)
        .navigation__block.navigation__block_prev

          .ajax__line.navigation__ajax

      template(v-if="!gettingLesson")
        .navigation__block.navigation__block_next.lesson-next(
          v-if="nextLesson.id && currentLesson.position !== storeCourse.numOfLessons"
        )
          //- p.navigation__descr Следующий урок

          router-link(:to="`${this.isFranch ? '/franch' : ''}/courses/lesson/${nextLesson.id}`").navigation__accent
            | Следующий урок
            //- | {{nextLesson.name}}
            Icon( icon="lesson-arrow")

      template(v-else)
        .navigation__block.navigation__block_prev
          .ajax__line.navigation__ajax



      .navigation__info
        p.navigation__descr(v-if="!gettingLesson")
          | {{currentLesson.position}} из {{storeCourse.numOfLessons}}

        .ajax__line.navigation__ajax(v-else)

    //-


</template>

<script>
import { mapState } from 'vuex';
import CourseLesson from '@/views/Courses/Course/layouts/Lesson';
import moment from 'moment-timezone';

moment.locale('ru');

export default {
  components: { CourseLesson },
  props: ['isAdminProp', 'isFranch'],
  data: () => ({
    roleType: 'admin'
  }),
  computed: {
    ...mapState('coursesLesson', {
      storeParts: s => s.data.parts,
      storeCourse: s => s.data.course,
      storeLessons: s => s.data.lessons,
      currentLesson: s => s.data.currentLesson,
      nextLesson: s => s.data.nextLesson,
      prevLesson: s => s.data.prevLesson,
      gettingLesson: s => s.meta.gettingLesson
    })
  },
  watch: {
    storeCourse(course) {
      if (course.id) {
        this.$store.dispatch('lms/setMultipleData', [
          {
            path: 'headerPrevLink',
            value: `${this.isFranch ? '/franch' : ''}/courses/course/${
              course.id
            }`
          }
        ]);
      }
    },
    currentLesson(lesson) {
      if (lesson.name) {
        this.$store.dispatch('lms/setMultipleData', [
          { path: 'headerTitle', value: `Урок: ${lesson.name}` }
        ]);
      }
    }
  }
};
</script>
